<template>
  <footer>
    <div id="contact">
      <a href="mailto:sharedcities@kek.org.hu">sharedcities@kek.org.hu</a>
      <a href="tel:+36305225994">+36 30 522 5994</a>
    </div>
    <div id="partners">
    <a class="link" href="http://kek.org.hu">
      <img src="../assets/kek-logo.svg">
    </a>
    <a class="link" href="https://www.sharedcities.eu/">
      <img src="../assets/sccm-logo.svg">
    </a>
    <a class="link" href="https://ec.europa.eu/programmes/creative-europe/">
      <img src="../assets/creative-eu.png">
    </a>
    </div>
  </footer>
</template>

<script>
  export default {
    name: 'csFooter',
  }
</script>

<style scoped>
  footer {
    display: flex;
    width: 100%;
    padding: 20px;
    min-height: 120px;
    justify-content: space-between;
    align-items: center;
    color: white;
    background: #222;
    box-sizing: border-box;
  }

  #contact,
  #partners {
    height: 50px;
  }

  #contact a {
    color: #fff;
    display: block;
    text-align: left;
  }

  .link {
    height: 50px;
    margin-left: 30px;
    z-index: 200;
  }

  .link:last-child {
    height: 45px;
    margin-right: 30px;
  }

  img {
    height: 100%;
  }

  @media (max-width: 600px) {
    footer {
      flex-direction: column;
    }

    a,
    a:last-child,
    #contact {
      margin: 0 0 30px;
    }

    #contact,
    #partners {
      height: auto;
    }

    #contact a {
      text-align: center;
      margin: 0 0 10px;
    }

    #partners .link {
      height: 60px;
      display: block;
      margin: 0 0 30px;
    }

    #partners .link:last-child {
      height: 40px;
      margin-right: 0;
    }
  }
</style>
